import type { ReactNode } from 'react';

import type { ButtonOrLinkData } from '#/components/ButtonOrLink/ButtonOrLinkData';

import { StyledLayoutHeaderButton } from './LayoutHeaderButton.styled';

type Props = {
  children: ReactNode;
  variant:
    | 'grey'
    | 'blue'
    | 'secondary'
    | 'green'
    | 'white'
    | 'blueGreenAnimate';
  minWidth?: number;
  smallHorizontalPadding?: boolean;
  centerHorizontally?: boolean;
  qaId?: string;
  ariaLabel?: string;
  roundBottomWhenOpen?: boolean;
  data: ButtonOrLinkData;
};

export function LayoutHeaderButton({
  children,
  variant,
  minWidth,
  smallHorizontalPadding,
  centerHorizontally,
  qaId,
  ariaLabel,
  roundBottomWhenOpen,
  data,
}: Props) {
  return (
    <StyledLayoutHeaderButton
      data-variant={variant}
      data-small-horizontal-padding={smallHorizontalPadding ? true : undefined}
      data-round-bottom-when-open={roundBottomWhenOpen ? true : undefined}
      data-center-horizontally={centerHorizontally ? true : undefined}
      style={{ minWidth }}
      qaId={qaId}
      aria-label={ariaLabel}
      data={data}
    >
      {children}
    </StyledLayoutHeaderButton>
  );
}
